// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/uScope/js/extensions/image-analysis/markup/markup-region.scss
// module id = 414
// module chunks = 0